import { IconProps } from './index';

const UserLocationFill: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                d="M8 13V21H0C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM16.828 19.828L14 22.657L11.172 19.828C10.6125 19.2686 10.2314 18.5559 10.0769 17.78C9.92251 17.004 10.0017 16.1997 10.3044 15.4687C10.6071 14.7377 11.1198 14.1129 11.7776 13.6734C12.4354 13.2338 13.2088 12.9991 14 12.9991C14.7912 12.9991 15.5646 13.2338 16.2224 13.6734C16.8802 14.1129 17.3929 14.7377 17.6956 15.4687C17.9983 16.1997 18.0775 17.004 17.9231 17.78C17.7686 18.5559 17.3875 19.2686 16.828 19.828ZM14 16C13.7348 16 13.4804 16.1054 13.2929 16.2929C13.1054 16.4804 13 16.7348 13 17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17C15 16.7348 14.8946 16.4804 14.7071 16.2929C14.5196 16.1054 14.2652 16 14 16Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default UserLocationFill;
